import React from "react";
import NavBar from "../components/ui/navbar";
import Chart from "../components/ui/chart";
import { Box } from "@chakra-ui/react";

function Page({ data }: { data: any }) {
  return (
    <>
      <NavBar data={data} selected="stocks" />
      <Box w="full" h="calc(100vh - 70px)">
        <Chart
          plotData={getPlotlyData(data.stockPerfData, data.dataDate)}
          title="Relative share prices"
          yaxis="Performance %"
        />
      </Box>
    </>
  );
}

function getPlotlyData(data: any, dataDate: string) {
  var plotly: any[] = [];

  data.map((s: any) => {
    const date = new Date(dataDate);
    var day = date.getDay();
    //let x = Array.from({ length: s.PercPerfs.length }, (e, i) => i);
    var x: Date[] = [];
    for (let i = 0; i < s.PercPerfs.length; i++) {
      if (day === 0) {
        date.setDate(date.getDate() - 2);
        day = 5;
      }
      x.push(new Date(date));
      date.setDate(date.getDate() - 1);
      day -= 1;
    }
    plotly.push({
      x: x,
      y: s.PercPerfs,
      visible: "legendonly",
      type: "scatter",
      mode: "lines",
      name: s.Name,
    });
  });
  return plotly;
}

export default Page;
